<template>
    <v-container fluid>
        <loader :loading="isloading"></loader>
        <v-card>
            <v-toolbar flat color="#1d2735" dark>
                <v-icon class="white--text" style="font-size: 45px">
                    mdi-chart-line
                </v-icon>
                <v-toolbar-title><h2>Informes</h2></v-toolbar-title>
            </v-toolbar>

            <v-tabs v-model="activeTab" background-color="transparent" color="basil" grow>
                <v-tab>
                    <v-icon left>mdi-checkbox-marked-circle-outline</v-icon>
                    Yotico
                </v-tab>
                
                <v-tab-item>
                    <v-card flat>
                        <InformeYotico />
                    </v-card>
                </v-tab-item>
            </v-tabs>
        </v-card>
    </v-container>
</template>

<script>
import InformeYotico from './componentes/InformeYotico.vue';
import loader from '../../base_components/base/Loader.vue';

export default {
    components: {
        InformeYotico,
        loader,
    },
    data() {
        return {
            activeTab: 0,
        };
    },
    mounted() {
        console.log('Componente Informes montado correctamente');
        console.log('Active tab:', this.activeTab);
    },
    computed: {
        isloading() {
            return this.$store.getters.getloading;
        },
    },
};
</script>

<style scoped>
.v-toolbar__title h2 {
    margin: 0;
    font-size: 1.5rem;
}
</style> 